import React, { FC } from "react";
import Card from "@material-ui/core/Card";

import { PageType } from "types/PageType";
import { useStyles } from "./styles";

const Expired: FC<PageType> = () => {
  const classes = useStyles({});

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100vh" }}>
      <div className={classes.root}>
        <Card className={classes.card}>
          Sorry, your public link has expired! Get a new one from
          kit@be-hookd.com
        </Card>
      </div>
    </div>
  );
};

export default Expired;
